import { ListItemText } from '@material-ui/core';
import { Form } from '@unform/web';
import styled from 'styled-components';

export const Wrapper = styled(Form)`
  p.Mui-error {
    margin-top: 0;
  }
`;

export const Container = styled.div`
  display: flex;
  position: relative;
`;

export const Sidebar = styled.ul`
  width: 18rem;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  position: absolute;
  right: 0;

  li {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 1rem;

    strong {
      font-size: 0.9rem;
      font-weight: 400;
      color: #999;
    }

    p {
      font-size: 1.3rem;
      color: #666;
    }

    :not(:last-child) {
      border-bottom: 1px solid rgba(0, 0, 0, 0.07);
    }

    &.active p {
      color: green;
      font-size: 1.5rem;
    }
  }
`;

export const ListItemField = styled(ListItemText)`
  .MuiListItemText-secondary {
    font-weight: bold;
  }
`;
